
import Tag from "../../../assets/duotone/Tag.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TagIcon({ className, dataTestid = "TagIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Tag data-testid={dataTestid} className={classes} {...rest} />
  );
}
